import React from "react";
import PropTypes from "prop-types"
import NumberFormat from "react-number-format";

const PositiveInput = (props) => {
    return (
        <div>
        <NumberFormat 
            thousandSeparator
            prefix={props.prefix}
            suffix={props.suffix}
            placeholder={props.placeholder}
            className={props.className}
            name={props.name}
            type={props.type}
            value={props.value}
            onChange={props.onChange}
            onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
                }
            }}
        >
        </NumberFormat>
        </div>
    )
}

export default PositiveInput

PositiveInput.propTypes = {
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func
  }